/** URLs Render (production) */
export const RENDER_FRONTEND_URL = 'https://web-frontend-y1r2.onrender.com';
export const RENDER_API_BASE = 'https://liberty-api-f6im.onrender.com';
export const RENDER_API_URL = `${RENDER_API_BASE}/api`;
export const RENDER_WS_URL = 'wss://liberty-api-f6im.onrender.com';

const isProdBuild = process.env.NODE_ENV === 'production';

/** Garantit que l'URL API se termine par /api (évite /profiles au lieu de /api/profiles). */
function normalizeApiUrl(raw) {
  let url = String(raw || '').trim().replace(/\/+$/, '');
  if (!url) return url;
  if (!/\/api$/i.test(url)) {
    url = `${url}/api`;
  }
  return url;
}

/** Admin sur :8080 → API + uploads sur le même IP sans ce port (ex. Hetzner). */
function runtimeBackendOriginFromBrowser() {
  if (typeof window === 'undefined' || !window.location?.hostname) return null;
  const { hostname, protocol, port } = window.location;
  if (hostname === 'localhost' || hostname === '127.0.0.1') return null;
  if (port && port !== '80' && port !== '443') {
    return `${protocol}//${hostname}`;
  }
  return null;
}

export const getApiUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return normalizeApiUrl(process.env.REACT_APP_API_URL);
  }
  const fromBrowser = runtimeBackendOriginFromBrowser();
  if (fromBrowser) return `${fromBrowser}/api`;
  return isProdBuild ? RENDER_API_URL : 'http://localhost:3000/api';
};

export const getBackendUrl = () => {
  if (process.env.REACT_APP_BACKEND_URL) {
    return String(process.env.REACT_APP_BACKEND_URL).replace(/\/$/, '');
  }
  const apiUrl = process.env.REACT_APP_API_URL;
  if (apiUrl) {
    return String(apiUrl).replace(/\/api\/?$/i, '').replace(/\/$/, '');
  }
  const fromBrowser = runtimeBackendOriginFromBrowser();
  if (fromBrowser) return fromBrowser;
  return isProdBuild ? RENDER_API_BASE : 'http://localhost:3000';
};

export const getWsUrl = () => {
  if (process.env.REACT_APP_WS_URL) {
    return String(process.env.REACT_APP_WS_URL).replace(/\/$/, '');
  }
  const backend = getBackendUrl();
  if (backend.startsWith('https://')) {
    return backend.replace(/^https:/, 'wss:');
  }
  if (backend.startsWith('http://')) {
    return backend.replace(/^http:/, 'ws:');
  }
  return isProdBuild ? RENDER_WS_URL : 'ws://localhost:3000';
};

export const getFrontendUrl = () =>
  process.env.REACT_APP_FRONTEND_URL ||
  (isProdBuild ? RENDER_FRONTEND_URL : 'http://localhost:3001');
